import React from 'react';
import { Linking, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

export default function AboutScreen() {
  const appInfo = {
    name: '聊天应用',
    version: '1.0.0',
    description: '一款简洁高效的实时聊天应用，支持单聊、群聊、视频通话等功能。',
  };

  const links = [
    { label: '官方网站', url: 'https://example.com' },
    { label: 'GitHub', url: 'https://github.com/example/chat-app' },
    { label: '使用协议', url: 'https://example.com/terms' },
    { label: '隐私政策', url: 'https://example.com/privacy' },
  ];

  const features = [
    '实时消息传输',
    '支持单聊和群聊',
    '视频语音通话',
    '文件传输',
    '位置分享',
    '表情包',
    '消息撤回和转发',
    '消息搜索',
  ];

  const handleLinkPress = (url: string) => {
    Linking.openURL(url);
  };

  return (
    <ScrollView style={styles.container}>
      <View style={styles.logoSection}>
        <View style={styles.logo}>
          <Text style={styles.logoText}>💬</Text>
        </View>
        <Text style={styles.appName}>{appInfo.name}</Text>
        <Text style={styles.version}>版本 {appInfo.version}</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.description}>{appInfo.description}</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>功能特性</Text>
        {features.map((feature, index) => (
          <View key={index} style={styles.featureItem}>
            <Text style={styles.bullet}>•</Text>
            <Text style={styles.featureText}>{feature}</Text>
          </View>
        ))}
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>相关链接</Text>
        {links.map((link, index) => (
          <TouchableOpacity
            key={index}
            style={styles.linkItem}
            onPress={() => handleLinkPress(link.url)}
          >
            <Text style={styles.linkLabel}>{link.label}</Text>
            <Text style={styles.linkArrow}>›</Text>
          </TouchableOpacity>
        ))}
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>技术支持</Text>
        <Text style={styles.supportText}>如有问题或建议，请联系我们：</Text>
        <TouchableOpacity onPress={() => handleLinkPress('mailto:support@example.com')}>
          <Text style={styles.email}>support@example.com</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.footer}>
        <Text style={styles.footerText}>© 2024 聊天应用. All rights reserved.</Text>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  appName: {
    color: '#333',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  bullet: {
    color: '#c9a227',
    fontSize: 18,
    marginRight: 8,
    marginTop: -2,
  },
  container: {
    backgroundColor: '#f5f5f5',
    flex: 1,
  },
  description: {
    color: '#666',
    fontSize: 14,
    lineHeight: 22,
  },
  email: {
    color: '#c9a227',
    fontSize: 16,
  },
  featureItem: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    marginBottom: 12,
  },
  featureText: {
    color: '#666',
    flex: 1,
    fontSize: 14,
  },
  footer: {
    alignItems: 'center',
    paddingVertical: 24,
  },
  footerText: {
    color: '#999',
    fontSize: 12,
  },
  linkArrow: {
    color: '#ccc',
    fontSize: 20,
  },
  linkItem: {
    alignItems: 'center',
    borderBottomColor: '#f5f5f5',
    borderBottomWidth: StyleSheet.hairlineWidth,
    flexDirection: 'row',
    paddingVertical: 14,
  },
  linkLabel: {
    color: '#333',
    flex: 1,
    fontSize: 16,
  },
  logo: {
    alignItems: 'center',
    backgroundColor: '#c9a227',
    borderRadius: 20,
    height: 80,
    justifyContent: 'center',
    marginBottom: 16,
    width: 80,
  },
  logoSection: {
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingVertical: 40,
  },
  logoText: {
    fontSize: 40,
  },
  section: {
    backgroundColor: '#fff',
    marginTop: 16,
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  sectionTitle: {
    color: '#333',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 16,
  },
  supportText: {
    color: '#666',
    fontSize: 14,
    marginBottom: 12,
  },
  version: {
    color: '#999',
    fontSize: 14,
  },
});
